import mapKnownValues from "@/utils/mapKnownValues";
import Property from "@/classes/property";
import Organization from "@/classes/organization";
import { StationStatus } from "./station";

export type StationDisconnectResponse = {
  serial: string;
  lastCommunication: string;
  propertyId: string;
  organizationId: string;
  clusterId: string;
  chargieId: string;
  disconnect: boolean;
  status?: string;
};

export interface StationDisconnectData extends StationDisconnectResponse {
  property: Property | null;
  organization: Organization | null;
}

export default class StationDisconnect {
  serial = "";
  lastCommunication: Date | null = null;
  property: Property | null = null;
  organization: Organization | null = null;
  chargieId = "";
  disconnect = true;
  status: StationStatus | null = null;

  constructor(params: Partial<StationDisconnectData> | StationDisconnect = {}) {
    mapKnownValues(this, params);
    if (params.property) {
      this.property = new Property(params.property);
    }
    if (params.organization) {
      this.organization = new Organization(params.organization);
    }
    if (params.lastCommunication) {
      this.lastCommunication = new Date(params.lastCommunication);
    }
  }

  get stationName() {
    if (this.chargieId) return this.chargieId;
    return this.serial;
  }
}
